import React from "react";
import * as S from "./index-styled";
import Info from "_c/atoms/Info";
import TinySlider from "_c/modules/profile/common/tiny-slider";
import PT from "prop-types";
import { generateAvatar } from "@/utils";
import isempty from "lodash/isEmpty";
import { LinkGenerator } from "@/utils/LinkGenerator";

const Masters = ({ isOwner, masters, t }) => {
  return (
    <S.Sect>
      <S.SliderWrap>
        <S.Title>{t("client_profile:titles.masters")}</S.Title>
        {isempty(masters) ? (
          <Info>
            {isOwner
              ? t("client_profile:blocks.masters_user")
              : t("client_profile:blocks.masters_guest")}
          </Info>
        ) : (
          <TinySlider
            data={masters.map(({ _id, user }) => ({
              avatar: generateAvatar({ url: user.avatar, sex: user.sex }),
              title: user.first_name,
              url: LinkGenerator.masterProfile(_id),
              id: _id,
            }))}
          />
        )}
      </S.SliderWrap>
    </S.Sect>
  );
};
Masters.propTypes = {
  isOwner: PT.bool,
  masters: PT.array,

  t: PT.func.isRequired,
};
export default Masters;
